export const paidPlansEnabled = (state: boolean = false): boolean => state
